// src/components/importData/components/DataTable.js
import React from 'react';
import { X, Upload } from 'lucide-react';
import { formatCurrency, formatPercentage } from '../utils/formatters';

const DataTable = ({ 
  data, 
  onValueChange, 
  onDeleteRow, 
  onReset,
  totalValue 
}) => {
  if (!data || data.length === 0) return null;

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold text-white">Portföy Detayı</h3>
        <div className="flex items-center space-x-4">
          <button
            onClick={onReset}
            className="text-gray-400 hover:text-gray-300"
          >
            <Upload className="w-5 h-5" />
          </button>
          <div className="text-sm text-gray-400">
            Toplam Değer: <span className="font-medium">{formatCurrency(totalValue)} TL</span>
          </div>
        </div>
      </div>
      
      <div>
        <table className="w-full">
          <thead>
            <tr className="bg-[#1e2536]">
              <th className="w-32 px-4 py-3 text-left text-sm font-medium text-gray-400 uppercase">
                SEMBOL
              </th>
              <th className="w-28 px-4 py-3 text-right text-sm font-medium text-gray-400 uppercase">
                ADET
              </th>
              <th className="w-28 px-4 py-3 text-right text-sm font-medium text-gray-400 uppercase">
                FİYAT
              </th>
              <th className="w-36 px-4 py-3 text-right text-sm font-medium text-gray-400 uppercase">
                TOPLAM
              </th>
              <th className="w-28 px-4 py-3 text-right text-sm font-medium text-gray-400 uppercase">
                MALİYET
              </th>
              <th className="w-36 px-4 py-3 text-right text-sm font-medium text-gray-400 uppercase">
                KAR/ZARAR
              </th>
              <th className="w-28 px-4 py-3 text-right text-sm font-medium text-gray-400 uppercase">
                AĞIRLIK
              </th>
              <th className="w-20 px-4 py-3 text-right text-sm font-medium text-gray-400 uppercase">
                İŞLEM
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => {
              const weight = (row.total / totalValue * 100);
              return (
                <tr key={index} className="border-t border-gray-800">
                  <td className="px-4 py-2">
                    <div className="inline-block rounded bg-gray-800/90 px-2 py-1 text-white">
                      {row.symbol}
                    </div>
                  </td>
                  <td className="px-4 py-2">
                    <input
                      type="number"
                      value={row.shares}
                      onChange={(e) => onValueChange(index, 'shares', e.target.value)}
                      className="w-full px-2 py-1 bg-[#1e2536] border border-gray-700 rounded text-right text-white"
                    />
                  </td>
                  <td className="px-4 py-2">
                    <input
                      type="number"
                      value={row.price}
                      onChange={(e) => onValueChange(index, 'price', e.target.value)}
                      className="w-full px-2 py-1 bg-[#1e2536] border border-gray-700 rounded text-right text-white"
                    />
                  </td>
                  <td className="px-4 py-2 text-right text-white">
                    {formatCurrency(row.total)}
                  </td>
                  <td className="px-4 py-2">
                    <input
                      type="number"
                      value={row.cost}
                      onChange={(e) => onValueChange(index, 'cost', e.target.value)}
                      className="w-full px-2 py-1 bg-[#1e2536] border border-gray-700 rounded text-right text-white"
                    />
                  </td>
                  <td className={`px-4 py-2 text-right ${row.profitLoss >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                    {formatCurrency(row.profitLoss)}
                  </td>
                  <td className="px-4 py-2 text-right text-white">
                    {formatPercentage(weight)}
                  </td>
                  <td className="px-4 py-2 text-center">
                    <button
                      onClick={() => onDeleteRow(index)}
                      className="text-red-400 hover:text-red-500"
                    >
                      <X className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DataTable;